<div class="file-viewer">
  <iframe
    *ngIf="src"
    class="file-viewer-frame"
    [src]="src"
    [title]="fileName"
  ></iframe>
  <div class="file-viewer-message" *ngIf="error">
    <mat-icon class="large">search_off</mat-icon><br />{{ error }}
  </div>
</div>
